import {
  CheckIcon,
  MonitorIcon,
  MoonIcon,
  SunIcon,
  SunMoonIcon,
  type LucideIcon,
} from 'lucide-react';
import type { ReactElement } from 'react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { useChatColorMode, useChatRoot, type ColorMode } from '../ChatProvider';

interface ModeOption {
  value: ColorMode;
  label: string;
  Icon: LucideIcon;
}

const OPTIONS: readonly ModeOption[] = [
  { value: 'light', label: 'Claro', Icon: SunIcon },
  { value: 'dark', label: 'Escuro', Icon: MoonIcon },
  { value: 'system', label: 'Sistema', Icon: MonitorIcon },
];

export function ColorModeMenu(): ReactElement {
  const { mode, setMode } = useChatColorMode();
  const chatRoot = useChatRoot();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          size="icon-lg"
          variant="ghost"
          aria-label="Mudar tema"
          title="Mudar tema"
          className="text-muted-foreground hover:text-foreground rounded-full"
        >
          <SunMoonIcon aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent container={chatRoot}>
        {OPTIONS.map(({ value, label, Icon }) => {
          const isActive = value === mode;
          return (
            <DropdownMenuItem
              key={value}
              onSelect={() => {
                setMode(value);
              }}
              aria-checked={isActive}
              role="menuitemradio"
            >
              <Icon aria-hidden />
              <span className="flex-1">{label}</span>
              {isActive && <CheckIcon aria-hidden className="text-muted-foreground" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
